import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '../utils/stringUtils';
import styles from './Card.module.css';
import tokens from '@metro-ui/tokens/css/custom-properties.module.css';
var camelMap = {
    none: 'None',
    'x-small': 'XSmall',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    'x-large': 'XLarge',
    'xx-large': 'XXLarge',
    full: 'XLarge',
};
var toCamel = function (str) { var _a; return (_a = camelMap[str]) !== null && _a !== void 0 ? _a : str; };
export var Card = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.padding, padding = _c === void 0 ? 'medium' : _c, _d = _a.elevation, elevation = _d === void 0 ? 'medium' : _d, _e = _a.radius, radius = _e === void 0 ? 'small' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, children = _a.children, _g = _a.overflowHidden, overflowHidden = _g === void 0 ? false : _g, htmlAttributes = __rest(_a, ["padding", "elevation", "radius", "className", "children", "overflowHidden"]);
    var cardClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompCard] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b[styles["padding".concat(toCamel(padding))]] = true,
        _b[styles["boxShadow".concat(toCamel(elevation))]] = true,
        _b[styles["borderRadius".concat(toCamel(radius))]] = true,
        _b[styles.overflowHidden] = overflowHidden,
        _b));
    return (React.createElement("div", __assign({}, htmlAttributes, { className: cardClassNames, ref: ref }), children));
});
Card.propTypes = {
    padding: PropTypes.oneOf([
        'none',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ]),
    elevation: PropTypes.oneOf(['medium', 'large', 'xx-large']),
    radius: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
    overflowHidden: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
//# sourceMappingURL=Card.js.map